import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from 'shared/components/buttons/Button/Button';
import { FlexBoxCenter, FlexBoxColumnAlign } from 'styles/layout';
import colors from 'styles/colors';

const FullHeightFlexBoxCenter = styled(FlexBoxCenter)`
  height: 100vh;
`;

const StyledPaper = styled(Paper)`
  padding: 2rem;
`;

const ErrorTypography = styled(Typography)`
  color: ${colors.error};
  margin-bottom: 1rem;
`;

const ProfileErrorPage = ({ error, onSignOut }) => (
  <FullHeightFlexBoxCenter>
    <StyledPaper elevation={3}>
      <FlexBoxColumnAlign>
        <ErrorTypography variant="h6">
          {error}
        </ErrorTypography>
        <Button variant="contained" color="primary" onClick={onSignOut}>
          Back to Login
        </Button>
      </FlexBoxColumnAlign>
    </StyledPaper>
  </FullHeightFlexBoxCenter>
);

ProfileErrorPage.propTypes = {
  error: PropTypes.string,
  onSignOut: PropTypes.func.isRequired,
};

export default ProfileErrorPage;
